import { render, staticRenderFns } from "./hdpItem.vue?vue&type=template&id=79230b04&lang=pug&"
import script from "./hdpItem.vue?vue&type=script&lang=js&"
export * from "./hdpItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports